import classes from "../classes";
import pure from "./higher-order/pure";
import React from "react";

export default pure(function TableHeaderTicketScore({ ticket }) {
  return (
    <div className="game-table_cell game-table_cell--ticket">
      <span className={classes({
        "tickets_score": true,
        "tickets_score--points": parseFloat(ticket.get("score")) > 0.0
      })}>
        {ticket.get("score")}
      </span>
    </div>
  );
});
